import axios from './axios-client';

const client = {

    /*
     * Alternative form for use by redux-saga
     */
    loadInstance_: (series) => {
        const filter = {series: series};
        const params = {
            filter: JSON.stringify(filter)
        };

        const promise = axios.get("/instances", {params: params});
        return promise;
    },

    /*
     * Sends a login request to the server to obtain a token
     */
    login: (username, password) => {
        const loginRequest = {
            username: username,
            password: password
        };
        const loginPost = axios.post("/login", loginRequest);
        return loginPost;
    },

    getRemainingTimeToRegister: (instanceId, onSuccess) => {
        const url = "/instances/" + instanceId + "/timeToRegister";
        axios.get(url)
            .then(res => {
                if (onSuccess) {
                    onSuccess(res.data);
                }
            })
            .catch(err => {

            });
    },

    deleteRegistrationEntry: (regEntryId, deleteEntry, jwtToken) => {
        const action = deleteEntry ? "/delete" : "/undelete";
        const url = "/entries/" + regEntryId + action;
        const promise = axios.post(url, null,{headers: {Authorization: 'Bearer ' + jwtToken}});
        return promise;
    },

    updateRegistrationEntry: (regEntry, jwtToken) => {
        // TODO code me!
        const url = "/entries/" + regEntry.id + "/update";
        const promise = axios.post(url, regEntry, {headers: {Authorization: 'Bearer ' + jwtToken}});
        return promise;
    },

    swapEntryPlayerOrder: (regEntryId, jwtToken) => {
        const url = "/entries/" + regEntryId + "/swapPlayerOrder";
        return axios.post(url, null, {headers: {Authorization: 'Bearer ' + jwtToken}});
    },

    /**
     * Returns the newest tournament instance for the given series
     */
    loadInstance: (series, onSuccess, onFailure) => {
        const filter = {series: series};
        const params = {
            filter: JSON.stringify(filter)
        };

        axios.get("/instances", {params: params})
        // FIXME: for the beginning, having it hard-coded is probably OK
        // should probably get /instances?filter={series:'Czech Open', latest: true}
            .then(res => {
                if (onSuccess) {
                    onSuccess(res.data[0]);
                }
            })
            .catch(error => {
                console.log("Error retrieving tournament instance data", error);
                if (onFailure) {
                    onFailure(error);
                }
            });
    },

    submitRegForm: (reg, onSuccess, onError) => {
        axios.post("/registrations", reg)
            .then((resp) => {
                if (onSuccess) {
                    onSuccess(resp.data);
                }
            })
            .catch((error) => {
                if (onError) {
                    onError(error);
                } else {
                    console.log(error);
                }
            });

    },

    submitRegFormAsync: (reg) => {
        const promise = axios.post("/registrations", reg);
        return promise;
    },

    loadExports: (instanceId, jwtToken) => {
        const url = "/instances/" + instanceId + "/exports";
        const config = {
            headers: {Authorization: 'Bearer ' + jwtToken}
        };
        const promise = axios.get(url, config);
        return promise;
    },

    downloadExport: (exportId, jwtToken) => {
        const url = "/exports/" + exportId;
        const config = {
            headers: {Authorization: 'Bearer ' + jwtToken},
            responseType: 'blob'
        };
        const promise = axios.get(url, config);
        return promise;
    },

    generateExport: (instanceId, jwtToken) => {
        const url = "/instances/" + instanceId + "/exports/generate";
        const config = {
            headers: {Authorization: 'Bearer ' + jwtToken}
        };
        const promise = axios.post(url, null, config);
        return promise;
    },

    deleteExport: (exportId, jwtToken) => {
        const url = "/exports/" + exportId + "/delete";
        const config = {
            headers: {Authorization: 'Bearer ' + jwtToken}
        };
        const promise = axios.post(url, null, config);
        return promise;
    },

    fetchPlayersAsync: (categoryId, filterString, includeDeletedPlayers) => {
        // for the admin interface, we want to include deleted
        const includeDeleted = typeof includeDeletedPlayers === 'undefined' ? true : includeDeletedPlayers;
        const filter = {includeDeleted: includeDeleted, searchString: filterString};
        const promise = axios.get('/category/' + categoryId + '/entries', {params: {filter: JSON.stringify(filter)}});
        return promise;
    },

    fetchPlayers: (categoryId, onSuccess, onError) => {
        axios.get('/category/' + categoryId + '/entries')
            .then(res => {
                if (onSuccess) {
                    onSuccess(res.data);
                }
            })
            .catch(error => {
                if (onError) {
                    onError(error);
                } else {
                    console.log("Unable to load entries for category " + categoryId, error);
                }
            })
    },
};

export default client;